import { data } from '../../svg/KeepOff/data';
import { makeIcon } from '../makeIcon';

export const KeepOff = makeIcon(data, 'keep_off', 'KeepOff');

export default KeepOff;
